export const GETSINGLECITY_CONTENT = 'GETSINGLECITY_CONTENT';
